 import { useState } from "react";
import uploadToCloudinary from "../utils/upload"; // 🔥 Tera Cloudinary Function

function CompleteProfileModal({ user, onClose, onSave }) {
  // 🏠 Address ko tod diya taaki specific details milein
  const [addr, setAddr] = useState({
    street: "",
    city: "",
    state: "",
    pincode: ""
  });

  const [idFile, setIdFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // Address fields update karne ka function
  const handleAddrChange = (e) => {
    setAddr({ ...addr, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    // 1. Validation: Sab kuch bhara hai ya nahi?
    if (!addr.street || !addr.city || !addr.state || !addr.pincode || !idFile) {
      return alert("⚠️ Bhai, Address pura bharo aur ID Proof upload karo!");
    }

    if (addr.pincode.length !== 6) {
      return alert("⚠️ Pincode 6 digits ka hona chahiye!");
    }

    setLoading(true);

    try {
      // 🔗 2. Combine Address into one String for Backend
      const fullAddress = `${addr.street}, ${addr.city}, ${addr.state} - ${addr.pincode}`;

      console.log("Uploading to Cloudinary... ☁️");

      // ☁️ 3. Upload Images to Cloudinary
      const idUrl = await uploadToCloudinary(idFile);
      
      // Profile pic optional hai, agar nayi hai to upload karo, warna purani rakho
      const profileUrl = profileFile ? await uploadToCloudinary(profileFile) : user.profilePic;

      // 💾 4. Update Backend
      const token = localStorage.getItem("token");
      const res = await fetch("https://borrowhub-backend.onrender.com/api/user/update-profile", {
        method: "PUT",
        headers: { 
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}` 
        },
        body: JSON.stringify({ 
            address: fullAddress, // Pura address ek string bankar jayega
            idProof: idUrl, 
            profilePic: profileUrl 
        }),
      });

      const data = await res.json();
      
      if (data.success) {
        // Local Storage & State Update
        const updatedUser = { ...user, address: fullAddress, idProof: idUrl, profilePic: profileUrl };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        
        alert("✅ Profile Verified! OTP Unlocked.");
        onSave(updatedUser);
      } else {
        alert("Error: " + data.message);
      }

    } catch (err) {
      console.error(err);
      alert("Something went wrong during upload.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.92)", backdropFilter: "blur(5px)" }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content border-0 shadow-lg">
          
          {/* 🔥 Header Section */}
          <div className="modal-header bg-warning text-dark border-bottom-0 p-4 d-flex flex-column align-items-center">
            <h2 className="modal-title fw-bold text-uppercase display-6">⚠️ One-Time Verification</h2>
            <p className="mb-0 mt-2 fw-semibold">
               Security ke liye ye details <u>sirf ek baar</u> bharni zaroori hain.
            </p>
          </div>

          <div className="modal-body p-5">
            
            {/* 🏠 1. Address Section (Specific Fields) */}
            <h5 className="fw-bold text-primary mb-3">1. Permanent Address 🏠</h5>
            
            <div className="mb-3">
              <label className="form-label small fw-bold text-muted">House No / Street / Colony</label>
              <input 
                type="text" 
                name="street"
                className="form-control form-control-lg" 
                placeholder="Ex: H.No 123, Gandhi Nagar"
                value={addr.street}
                onChange={handleAddrChange}
              />
            </div>

            <div className="row">
              <div className="col-md-5 mb-3">
                <label className="form-label small fw-bold text-muted">City</label>
                <input 
                  type="text" 
                  name="city"
                  className="form-control" 
                  placeholder="Ex: Mumbai"
                  value={addr.city}
                  onChange={handleAddrChange}
                />
              </div>
              <div className="col-md-4 mb-3">
                 <label className="form-label small fw-bold text-muted">State</label>
                 <input 
                  type="text" 
                  name="state"
                  className="form-control" 
                  placeholder="Ex: Maharashtra"
                  value={addr.state}
                  onChange={handleAddrChange}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label small fw-bold text-muted">Pincode</label>
                <input 
                  type="number" 
                  name="pincode"
                  className="form-control" 
                  placeholder="000000"
                  maxLength="6"
                  value={addr.pincode}
                  onChange={handleAddrChange}
                />
              </div>
            </div>

            <hr className="my-4 text-muted" />

            {/* 🆔 2. ID Proof Section */}
            <h5 className="fw-bold text-primary mb-3">2. Upload Documents 📂</h5>
            
            <div className="mb-4">
              <label className="form-label fw-bold">Upload Govt ID (Aadhaar / DL)</label>
              <div className="input-group">
                <input 
                    type="file" 
                    className="form-control" 
                    accept="image/*" 
                    onChange={(e) => setIdFile(e.target.files[0])} 
                />
                <span className="input-group-text bg-light">🔒 Secure</span>
              </div>
              <small className="text-danger">*Mandatory for Verification</small>
            </div>

            {/* 👤 3. Profile Pic */}
            <div className="mb-4">
              <label className="form-label fw-bold">Profile Photo (Selfie)</label>
              <input 
                type="file" 
                className="form-control" 
                accept="image/*" 
                onChange={(e) => setProfileFile(e.target.files[0])} 
              />
              <small className="text-muted">(Optional, but recommended)</small>
            </div>

            {/* 💾 Save Button */}
            <button 
                className="btn btn-dark w-100 py-3 fw-bold fs-5 shadow-sm" 
                onClick={handleSave} 
                disabled={loading}
            >
              {loading ? (
                <span>⏳ Uploading to Secure Server...</span>
              ) : (
                <span>💾 SAVE DETAILS & SHOW OTP 🔓</span>
              )}
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}

export default CompleteProfileModal;